const search = {
  status: 200,
  message: '',
  data: {
    // 29 下限 TODO: Done
    feeUpper: [
      {
        searchParam: 'feeUpper',
        displayName: '1,000円',
        value: '1000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '2,000円',
        value: '2000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '3,000円',
        value: '3000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '4,000円',
        value: '4000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '5,000円',
        value: '5000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '6,000円',
        value: '6000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '7,000円',
        value: '7000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '8,000円',
        value: '8000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '9,000円',
        value: '9000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '10,000円',
        value: '10000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '12,000円',
        value: '12000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '14,000円',
        value: '14000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '16,000円',
        value: '16000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '18,000円',
        value: '18000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '20,000円',
        value: '20000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '30,000円',
        value: '30000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '40,000円',
        value: '40000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '50,000円',
        value: '50000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '100,000円',
        value: '100000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '150,000円',
        value: '150000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '200,000円',
        value: '200000',
        total: 0
      }
    ],

    // 30 上限 TODO: Done
    feeLower: [
      {
        searchParam: 'feeLower',
        displayName: '1,000円',
        value: '1000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '2,000円',
        value: '2000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '3,000円',
        value: '3000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '4,000円',
        value: '4000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '5,000円',
        value: '5000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '6,000円',
        value: '6000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '7,000円',
        value: '7000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '8,000円',
        value: '8000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '9,000円',
        value: '9000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '10,000円',
        value: '10000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '12,000円',
        value: '12000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '14,000円',
        value: '14000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '16,000円',
        value: '16000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '18,000円',
        value: '18000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '20,000円',
        value: '20000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '30,000円',
        value: '30000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '40,000円',
        value: '40000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '50,000円',
        value: '50000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '100,000円',
        value: '100000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '150,000円',
        value: '150000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '200,000円',
        value: '200000',
        total: 0
      }
    ]
  }
}

// Bỏ 10, 32, 33.
export default search
